import AuthBgWrapper from '@/features/auth/components/auth-bg-wrapper'
import AuthCardWrapper from '@/features/auth/components/auth-card-wrapper'
import LoginByOtpForm from '@/features/auth/components/forms/login-form/login-form-by-otp'
import LoginFormProvider from '@/features/auth/components/forms/login-form/login-form-provider'
import { loginScreenBgImage } from '@/features/auth/constants/image'
import React, { Suspense } from 'react'

function OtpLoginPage() {
    return (
        <AuthBgWrapper image={loginScreenBgImage}>
            <AuthCardWrapper
                headerTitle='Welcome Back!'
                headerDescription='Log in to your account using your email and password to continue.'
            >
                <LoginFormProvider>
                    <Suspense fallback={<div>Loading...</div>}>
                        <LoginByOtpForm />
                    </Suspense>
                </LoginFormProvider>
            </AuthCardWrapper>
        </AuthBgWrapper>
    )
}

export default OtpLoginPage